import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/apiClient";
import { useAuth } from "../../context/AuthContext.js";
import { DatePicker, message } from "antd";
import "../../style/CreateAuction.css";

function AuctionForm() {
  const { id } = useParams();
  const { authToken, logout } = useAuth();
  const [username, setUsername] = useState("");
  const [carro, setCarro] = useState(null);
  const [precioInicial, setPrecioInicial] = useState("");
  const [salto, setSalto] = useState("");
  // moment objects (antd v4 DatePicker), null until picked.
  const [inicio, setInicio] = useState(null);
  const [fin, setFin] = useState(null);

  const navigate = useNavigate();

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching user", error);
    }
  };

  const getCar = async () => {
    try {
      const res = await api.get("carro/" + id);
      setCarro(res.data);
    } catch (error) {
      console.error("Error fetching car", error);
    }
  };

  useEffect(() => {
    if (!authToken) {
      navigate("/");
    }
    getuser();
    getCar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createAuction = async () => {
    if (!precioInicial || !salto || !inicio || !fin) {
      message.warning("Completa precio, incremento, inicio y fin");
      return;
    }
    if (!fin.isAfter(inicio)) {
      message.warning("El fin debe ser después del inicio");
      return;
    }
    try {
      await api.post("auctions/", {
        Carro: id,
        PrecioInicial: Number(precioInicial),
        Salto: Number(salto),
        Inicio: inicio.toISOString(),
        Fin: fin.toISOString(),
      });
      message.success("Subasta creada");
      navigate("/createauction");
    } catch (error) {
      console.error("Error creating auction", error);
      message.error(error.response?.data?.error || "Error creando la subasta");
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Crear Subasta</p>
            {carro && (
              <div className="auction-form-wrapper">
                <div className="car-preview">
                  <div className="preview-main">
                    <img src={carro.imagenes?.[0]} alt={`${carro.marca} ${carro.modelo}`} />
                    <div className="car-meta">
                      <p className="car-title-auction">{carro.marca} {carro.modelo} {carro.anio}</p>
                      <p className="car-detail-line">Lote: {carro.lote}</p>
                      <p className="car-detail-line">Motor: {carro.motor}</p>
                      <p className="car-detail-line">Millaje: {carro.millaje}</p>
                      <p className="car-detail-line">Combustible: {carro.combustible}</p>
                      <p className="car-detail-line">Precio base: L. {carro.precio}</p>
                    </div>
                  </div>
                  {carro.imagenes?.length > 1 && (
                    <div className="preview-gallery">
                      {carro.imagenes.slice(1, 5).map((img, idx) => (
                        <img key={idx} src={img} alt={`Vista ${idx + 2}`} />
                      ))}
                    </div>
                  )}
                </div>

                <div className="auction-form">
                  <p className="car-title-form"><strong>{carro.marca} {carro.modelo} {carro.anio}</strong></p>
                  <input
                    type="number"
                    className="input-admin"
                    placeholder="Precio inicial"
                    value={precioInicial}
                    onChange={(e) => setPrecioInicial(e.target.value)}
                  />
                  <input
                    type="number"
                    className="input-admin"
                    placeholder="Incremento"
                    value={salto}
                    onChange={(e) => setSalto(e.target.value)}
                  />
                  <label className="label-admin">Inicio</label>
                  <DatePicker
                    className="input-admin auction-datepicker"
                    showTime={{ use12Hours: true, format: "hh:mm A", minuteStep: 5 }}
                    format="DD/MM/YYYY hh:mm A"
                    placeholder="Fecha y hora de inicio"
                    value={inicio}
                    onChange={setInicio}
                  />
                  <label className="label-admin">Fin</label>
                  <DatePicker
                    className="input-admin auction-datepicker"
                    showTime={{ use12Hours: true, format: "hh:mm A", minuteStep: 5 }}
                    format="DD/MM/YYYY hh:mm A"
                    placeholder="Fecha y hora de fin"
                    value={fin}
                    onChange={setFin}
                  />
                  <button id="search" onClick={createAuction}>Crear Subasta</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default AuctionForm;
